module.exports = __webpack_public_path__ + "img/media_4.077730a9.jpg";